// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36w97","content":"styles_content__281Zi","row":"styles_row__1yhg0","footer":"styles_footer__1L42t","phraseLength":"styles_phraseLength__2s_NP"};